import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {Ellipsis} from "../../../../core/components/misc/ellipsis/ellipsis";

export const NewSearchWidgetEntitiesItemInfo = observer(({controller, entity, isRecentSearchesList}) => {
  const {state, device} = controller;
  const {isAllSportsFilter} = state;
  const {isSmallView} = device;

  const sportTypeText: String = isAllSportsFilter ? `${entity.sport.name} · ` : ''
  const entitySubtext: String = isAllSportsFilter ? `${sportTypeText}${entity.country.name}` : `${entity?.clubName || entity.country.name}`;

  return (
    !isRecentSearchesList || !isSmallView ? <div className={classNames(styles.entity_item_info)}>
      <div className={classNames(styles.entity_item_name)}>{entity.name}</div>
      <div className={classNames(styles.entity_item_subtext)}>{entitySubtext}</div>
    </div> : <Ellipsis className={classNames(styles.entity_item_name)} text={entity.name} numOfMaxLines={2}/>
  )
});
